export const UIPaths =  {
  login: '/login',
  loginPrefilled: '/login/:prefilled',
  register: {
    step1: '/signup',
    step1WithCustomerCode: '/signup/:customerCode?',
    referralSignup: '/referral-signup/:checkoutSessionID'
  },
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',//'/reset-password/:magicToken?',
  dashboard: '/dashboard/home',
  // matomoAnalytics: '/store-analytics',
  howTo: {
    list: '/how-to',
    detail: '/how-to/:guideCode',
  },
  unAuthorized: '/misc/not-authorized',
  // attribute: {
  //   list: '/variation/list',
  //   detail: '/variation/detail/:attributeID',
  // },
  // productCategory: {
  //   list: '/product-category/list',
  //   detail: '/product-category/detail/:productCategoryID',
  //   metaData: '/product-category/metadata/:productCategoryID',
  // },
  product: {
    list: '/product/list',
    detail: '/product/detail/:productID',
    images: '/product/images/:productID',
    metaData: '/product/metadata/:productID',
    bulkUpload: '/product/bulkUpload',
  },
  user: {
    list: '/customer/list',
    addNew: '/customer/detail',
    detail: '/customer/detail/:emailID',
    bulkAddTag: '/customer/segementation-add-tag',
    bulkRemoveTag: '/customer/segementation-remove-tag',
  },
  userDashboardMgmt: {
    list: '/user/list',
    newUser:'/user/add', 
    detail: '/user/detail/:emailID',
  },
  store : {
    aboutStore: '/about-store',
    contactDetails: '/about-store/contact-details',
    license: '/about-store/manage-subscription',
    appSumoLicense: '/about-store/manage-appsumo-subscription',
    subscriptionPaymentSuccessful: '/subscription-successful',
    licenseDetails: '/about-store/plan-details',
    // subscriptionPaymentCancelled: '/about-store/subscription-payment-cancelled'
  },




  // --------------------------------------------

  entity: {
    list: '/entity/list',
    newEntity:'/entity/detail/0',
    detail:'/entity/detail/:entityID',
    document: '/entity/document/:entityID',
    team:'/entity/team/:entityID',
    manageCompliances:'/entity/manage-compliances/:entityID',
    obligations:'/entity/obligations/:entityID',
    obligationDetails:'/entity/obligations/:entityID/:obligationID',
    addCompliances: '/entity/add-compliances',
    controls: '/entity/controls/:entityID',
    policies:'/entity/policy/:entityID',
    policyDocument: '/entity/detail/:entityID/policy/:policyID',
    event: {
      list: '/entity/event/:entityID',
      trigger: '/entity/event-trigger/:entityID',
    },
    // managePolicies: '/entity/manage-policies/:entityID'
    framework: {
      list: "/entity/framework/:entityID",
      recommendation: '/entity/framework-recommendation/:entityID',
      report: "/entity/framework-report/:entityID",
      reportAuditChecklist: "/audit-checklist/:entityID/:reportID",
      obligations:'/entity/framework/:frameworkID/obligations/:entityID',
      obligationDetails:'/entity/framework/:frameworkID/obligations/:entityID/:obligationID',
    },
    securities: {
      list: '/entity/securities/list',
      detail: '/entity/securities/detail/:securityID'
    },
    sources:{
      list: '/entity/sources/list',
      detail: '/entity/sources/detail/:dataSourceID'
    },
    // frameworkList: "/entity/framework/:entityID",
    // frameworkRecommendation: '/entity/framework-recommendation/:entityID'
    vendor: {
      list: '/vendor/list',
      detail: '/vendor/detail/:vendorID'
    }
  },

  repo: {
    complianceList: '/repo/compliance/list',
    complianceWizard: '/repo/compliance/detail/:complianceID',
    policy: {
      list: '/repo/policy/list',
      detail: '/repo/policy/detail/:policyID',
      document: '/repo/policy/document/:policyID'
    },
    circular: {
      regulatorList: '/repo/circulars',
      regulatorDetail: '/repo/circulars/:regulatorTypeCodeID'
    },
    complianceImport: '/repo/compliance/import'
  },
  taskBuilder: {
    list: '/taskBuilder/list',
    detail: '/taskBuilder/detail/:complianceID'
  },
  // policy: {
  //   list: '/repo/policy/list',
  //   detail: '/repo/policy/detail'
  // },
  compliance: {
    categoryCardList: '/compliance/categories',
    listByCategory: '/compliance/categories/:categoryID',
  },

  event: {
    list: '/event/list',
    trigger:'/event/trigger',
    taskList:'/event-tasks/:entityEventID',
  },

  upcomingTask: {
    list: '/pending-tasks',
    detail: '/pending-tasks/:taskNumber',
  },

  allTask: {
    list: '/all-tasks',
    detail: '/all-tasks/:taskNumber',
  },

  complianceLeftMenu: {
    list: '/compliance/list',
    detail: '/compliance/detail',
    assignComplianceToEntities: '/compliance/assign-entities'
  },

  alertBoard: {
    dashboard: '/alert-board'
  },
  cSuiteBoard: {
    dashboard: '/risk-board',
    monetaryRisk:{
      taskList:'/risk-board/monetary-risk-tasks',
      detail: '/risk-board/monetary-risk-tasks/:taskNumber'
    },
    riskMatrix:{
      taskList:'/risk-board/risk-matrix-tasks',
      detail: '/risk-board/risk-matrix-tasks/:taskNumber'
    }
  },
  auditor: {
    resourcesQuery: '/auditor-resources',
    resourcesResult: '/auditor-resources/result',
    detail: '/audit-details',
    remarks: '/audit-remarks'
  },
  taskTracker: {
    report: '/task-tracker',
    create: '/task-tracker/create-task',
    detail: '/task-tracker/:taskNumber',
  },
  advancedReports: {
    list: '/advanced-reports'
  },
  user: {
    list: '/user/list',
    detail: '/user/detail/:emailID',
    addNew: '/user/detail',
  },
  role: {
    list: '/role/list',
    detail: '/role/detail/:roleID',
    addNew: '/role/detail',

    access: '/role/access'
  },

  template: {
    designerView: '/template/designer'
  },
  myProfile: {
    notificationSettings: '/notification-settings', 
    notificationList:'/notification-list'
  },

  // --------------------------------------------
  risk: {
    register: {
      list: '/risk-register/list',
      detail: '/risk-register/detail/:riskNumber',
    },
    framework : {
      list: "/entity/framework/:entityID",
      detail:'/risk-framework/detail/:frameworkID',

      section : {
        list: '/risk-framework/sections/:frameworkID',
        detail:'/risk-framework/sections/:frameworkID',
      },
    },
    assessment: {
      list: '/risk-assessment/list',
      detail: '/risk-assessment/detail/:assessmentID',
    },
    monitor: {
       list: '/risk-monitor/list',
    },
    team:'/entity/team/:entityID',
    manageCompliances:'/entity/manage-compliances/:entityID',
    addCompliances: '/entity/add-compliances',
    policyDocument: '/entity/detail/:entityID/policy/:policyID',

    risk: {
      detail: '/risk/detail/:riskNumber'
    }
    
    // managePolicies: '/entity/manage-policies/:entityID'
  },
  ropa: {
    report: '/ropa/:entityID',
    detail: '/ropa/:entityID/:activityCode'
  }
}

export const SPQueryStringParam = {
  lastModifiedOnDesc: '?q=lmo',
  addCategoryFromProductDetails: '?q=apd',
  restoreSearch: '?q=rsp',
  redirectToPage: '?q=rp-rpt',
  wooCommerceImportFromProductList: '?q=wc',
}
